import { render } from "./Appointment.vue?vue&type=template&id=60cb50d9&scoped=true"
import script from "./Appointment.vue?vue&type=script&lang=js"
export * from "./Appointment.vue?vue&type=script&lang=js"

import "./Appointment.vue?vue&type=style&index=0&id=60cb50d9&lang=scss&scoped=true"

import exportComponent from "/tmp/build_195c5171/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cb50d9"]])

export default __exports__